import React, { useState, useEffect } from "react";

import {
    Avatar,
    Chip,
    colors,
    Container,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    Slide,
    Typography,
} from "@material-ui/core";

import { uri } from "../../../help/Api";
import { useHistory } from "react-router-dom";
import {
    useStylesCAB,
    useStylesContainers,
    useStylesDPM,
    useStylesHed,
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../St/comps/UseStyle";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import moment from "moment";
import axios from "axios";
import { insh, sto, wsto } from "../../../Context/InshData";
import { useStylesBA } from "../../../St/comps/UseStyle";
import { getLS } from "../../../utils/useLS";
import toast from "react-hot-toast";

import { GetItemFromOptions } from "../../../services/global-services";
import EmployeeAdvancesForm from "./EmployeeAdvancesForm";
import EmployeeAdvancesAppBar from "./EmployeeAdvancesAppBar";
import { reFormatDate } from "../../../utils/utils";
import EmployeeSalarySearch from "../employeesSalary/EmployeeSalarySearch/EmployeeSalarySearch";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import DeleteConfirmDialog from "../../../components/DeleteConfirmDialog";
const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: "#f1f1fa",
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: "#f1f1fa",
        borderColor: "#4a82b9",
    },
    avatar: {
        backgroundColor: "#4a82b9",
        color: "#fff",
        height: 46,
        width: 46,
        marginTop: -5,
    },
    icon: {
        height: 32,
        width: 32,
    },
}));

export default function EmployeeAdvances(props) {

    const { AutoOptions, branch, setBranch } = props;
    const [costCenters, setCostCenters] = useState(() => {
        return [{ id: -1, name: "بدون" }, ...AutoOptions?.center ?? []];
    });
    const valuebranch = GetItemFromOptions(sto.branchi, AutoOptions.Branches ?? []);
    const clashd = useStylesHed();

    const clasess = useStyles();
    const months = [
        { id: 1, name: 'يناير' },
        { id: 2, name: 'فبراير' },
        { id: 3, name: 'مارس' },
        { id: 4, name: 'أبريل' },
        { id: 5, name: 'مايو' },
        { id: 6, name: 'يونيو' },
        { id: 7, name: 'يوليو' },
        { id: 8, name: 'أغسطس' },
        { id: 9, name: 'سبتمبر' },
        { id: 10, name: 'أكتوبر' },
        { id: 11, name: 'نوفمبر' },
        { id: 12, name: 'ديسمبر' },
    ];
    const AdvancesState = [
        { id: 0, name: 'مفتوحة' },
        { id: 1, name: 'مقفلة' },
    ];
    const years = Array.from({ length: 50 }, (_, i) => {
        const year = new Date().getFullYear() - i;
        return { id: year, name: year.toString() };
    });
    const datas = {
        id: AutoOptions.other.lastid,
        no: AutoOptions.other.lastid,
        date: moment(new Date()).format('YYYY-MM-DD'),
        month: months[0].id,
        year: years[0].id,
        branch: sto.branchi,
        emp: "",
        amount: 0,
        emp_resp: AutoOptions?.Employees[0].id,
        notes: "",
        IS_Deleted: "",
        center: costCenters[0].id,
        safe_bank_id: AutoOptions.Stocks[0].id,
        type: 1,
        rest_id: "",
        create_user: sto.idi,
        update_user: "",
        update_date: "",
        state: AdvancesState[0].id,
        kind: 1,
        db_name:sto?.db_name??""
    };


    const inshValueAuto = {
        branch: valuebranch,
        emp: {},
        emp_resp: AutoOptions?.Employees[0],
        center: costCenters[0],
        safe_bank_id: AutoOptions.Stocks[0],
        month: months[0],
        year: years[0],
        type: { name: "type", value: 1 },
        state: AdvancesState[0],
    };

    const [params, setParams] = useState({
        ...datas,
        branch:valuebranch.id,
    });


    const [valueAutos, setValueAutos] = useState(inshValueAuto);


    const clasBA = useStylesBA();

    const clasCAB = useStylesCAB();
    const locSto = getLS("sto", {});
    const [loading, setLoading] = useState(insh.LoadAndSucc);
    const [success, setSuccess] = useState(insh.LoadAndSucc);
    const [isLoading, setIsLoading] = useState(false);
    const [openUpdate, setOpenUpdate] = useState(false);
    const [openButtonsSearch, setOpenButtonsSearch] = useState(false);
    const [procIdSearch, setProcIdSearch] = useState(0);

    const [showPic, setShowPic] = useState(false);
    const [or, setOr] = useState(insh.Or);

    const inshParm = { itake: 20, symple: "", groupSearch: null };
    const [parm, setParm] = useState(inshParm);

    const timer = React.useRef();
    const [uiElement, setUiElement] = useState({});

    const [transition, setTransition] = React.useState(undefined);


    const [setting, setSetting] = useState({
        screen: "",
        tb: { parms: {}, autos: {} },
    });

    const [style, setStyle] = useState({});

    const buttonClassnameNew = clsx({ [clasCAB.buttonSuccessCAB]: success.new });
    const buttonClassnameSave = clsx({
        [clasCAB.buttonSuccessCAB]: success.save,
    });
    const buttonClassnameDelete = clsx({
        [clasCAB.buttonSuccessCAB]: success.delete,
    });

    const [prevent, setPrevent] = useState(true);

    // const ust_o = (updatedData) => {
    function usto(olddata) { }

    const [openSearchMdl, setOpenSearchMdl] = useState(false);

    const handCloseDw = () => {
        setOpenSearchMdl(false);
    };

    const changAutos = (prop, newValue) => {
        setValueAutos({ ...valueAutos, [prop]: newValue })
        setParams({
            ...params,
            branch: newValue.id
        });
        reloadGets(newValue, true);
        setPrevent(false);
    };

    const onChangeAuto = (prop, newValue) => {
        if (prop === "branch") {
            setParams({ ...params, [prop]: newValue.id });
            setBranch(newValue);
            setValueAutos({ ...valueAutos, [prop]: newValue });
        }
        else {
            setValueAutos({ ...valueAutos, [prop]: newValue });
            setParams({ ...params, [prop]: newValue.id });
        }
    };


    const onChange = (prop) => (e) => {
        setParams({ ...params, [prop]: e.target.value });
    };

    const ButtonLoading = (prop) => setLoading({ ...loading, [prop]: true });

    const ButtonWitting = (prop) => {

    };
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };




    const ButtonSuccess = (prop, timr) => {
        timer.current = window.setTimeout(() => {
            setLoading({ ...loading, [prop]: false });
            setSuccess({ ...success, [prop]: true });
            if (prop === "print") { print(); }
            else if (prop === "save") { handNewItem(); }
            else if (prop === "delete") { handNewItem(); }
            else {
                handNewItem();
            }
        }, timr);
    };


    const newToI = (timr) => {
        setIsLoading(true);
        ButtonLoading("new");
        ButtonSuccess("new", timr);
        setPrevent(true);
    };


    const [snack, setSnack] = React.useState(insh.Snack);

    const handOSnack = (newState) => {
        setSnack({ openSnak: true, ...newState });
    };


    const reloadGets = async () => {
        const tb = {
            wait: true,
            other: true,
            parms: {
                iempid: sto.empi,
                branch: sto.branchi,
                tname: "advance",
                db_name:sto?.db_name
            },
        };

        await axios
            .post(uri + "GetD", tb)
            .then((res) => {
                setParams({
                    ...datas,
                    no: res.data.other.lastid,
                });
            })
            .catch((error) => {

            });
    };
    const onClickButton = async (procId, type) => {
        const tb = {
            ButtonSearchAdvance: true,
            stor: sto,
            parms: {
                tname: type,
                branch: sto.branchi,
                iprocid: procId,
                db_name:sto?.db_name
                // type: IsOpen ? 11 : 10,
            },
        };
        axios
            .post(uri + "GetD", tb)
            .then((res) => {
                setProcIdSearch(res.data?.advances_data?.id);
                if (res.data?.advances_data.id > 0) {
                    setPrevent(false);
                    onRowClicks(res.data.advances_data);
                }
            })
            .catch((error) => {
            });
    };
    const onRowClicks = (data) => {

        setParams({
            ...data,
            branch: data.branch,
            date: reFormatDate(data.date),
            id: data.id,
            update_user: sto.idi,
            update_date: moment(new Date()).format('YYYY-MM-DD'),
        });

        let res = { branch: {}, center: {}, bank: {}, stock: {}, emp: {}, emp_resp: {}, month: {}, year: {}, state: {} };
        AutoOptions.Branches.map((x) => {
            if (x.id == data.branch) res.branch = x;
        });
        AutoOptions.Employees.map((x) => {
            if (x.id == data.emp) res.emp = x;
        });
        AutoOptions.Employees.map((x) => {
            if (x.id == data.emp_resp) res.emp_resp = x;
        });
        AutoOptions.Stocks.map((x) => {
            if (x.id == data.safe_bank_id) res.stock = x;
        });
        costCenters.map((x) => {
            if (x.id == data.center) res.center = x;
        });
        months.map((x) => {
            if (x.id == data.month) res.month = x;
        });
        years.map((x) => {
            if (x.id == data.year) res.year = x;
        });
        AutoOptions.Banks.map((x) => {
            if (x.id == data.safe_bank_id) res.bank = x;
        });
        AdvancesState.map((x) => {
            if (x.id == data.state) res.state = x;
        });
        setValueAutos({
            ...valueAutos,
            center: res.center,
            branch: res.branch,
            month: res.month,
            year: res.year,
            safe_bank_id: data.type == 1 ? res.stock : res.bank,
            emp: res.emp,
            emp_resp: res.emp_resp,
            state: res.state,
        });
        setOpenSearchMdl(false);
        setPrevent(false);
        setUiElement({ ...uiElement, DeleIcon: true });
        timer.current = window.setTimeout(
            () => setUiElement({ ...uiElement, DeleIcon: true }),
            300
        );
    };
    const print = () => {

        const info = {
            data: [],
            tot: null,
            type: 2,
            title: "سلفة للموظف     " + valueAutos.emp.name + " " + "شهر  " + valueAutos.month.name + "   " + "سنة  " + valueAutos.year.name,
            emp: valueAutos.emp.name,
            kind: params.type == 1 ? "نقدا" : params.type == 2 ? "شبكة" : "تحويل",
            amount: params.amount,
            month: valueAutos.month.name,
            year: valueAutos.year.name,
            notes: "سلفة    " + " " + "شهر  " + valueAutos.month.name + "   " + "سنة  " + valueAutos.year.name,
            date: moment(params.date).format("YYYY-MM-DD"),
            tDate: "00:00:00",
        };

        localStorage.setItem("iInfos", JSON.stringify(info));
        his.push({ pathname: "/SalaryPrint" });
        window.location.reload(false);
    };
    const handNewItem = () => {
        reloadGets();
        setPrevent(true);
        setValueAutos(inshValueAuto);
        setIsLoading(false);
        setIsLoading(false);
        setOpenUpdate(false);
        setOpenButtonsSearch(false);
        setProcIdSearch(0);
    };
    const will = () => {
        let ob = "yes";
        if (params.emp == "" || params.emp == null) {
            ob = "no";
        } else if (params.branch == "" || params.branch == null) {
            ob = "no";
        } else if (params.amount == "" || params.amount == null) {
            ob = "no";
        } else {
            ob = "yes";
        }
        return ob;
    };
    const addChangds = () => {
        params.date =
            moment(params.date).format("YYYY-MM-DD") +
            moment(new Date()).format(" h:mm A");
    };
    const addToBS = (props) => {
        let action = will();

        if (action == "yes") {
            addChangds();
            ButtonLoading("save");
            setIsLoading(true);
            console.log("the curre data is ", params);


            prevent
                ? axios
                    .post(uri + "EmployeeAdvances", params)
                    .then((res) => {
                        if (res.data) {
                            toast.success(t("save-success"));
                            ButtonSuccess(props, 500);

                        } else {
                            ButtonWitting("save");
                            // reloadGets(valueAutos.branch, false);
                            toast.success(t("save-success"));
                            ButtonSuccess(props, 1000);
                        }
                    })
                    .catch((res) => {
                        toast.error(t("save-failed"));
                        // reloadGets(valueAutos.branch, false);
                        ButtonSuccess("save", 1000);
                    })
                :
                axios
                    .put(uri + "EmployeeAdvances", params)
                    .then((res) => {
                        toast.success(t("update-success"));
                        // reloadGets(valueAutos.branch, false);
                        ButtonWitting("save");
                        ButtonSuccess(props, 1000);

                    })
                    .catch((res) => {
                        // reloadGets(valueAutos.branch, false);
                        ButtonSuccess("save", 1000);
                        toast.error(t("update-failed"));
                    });
        } else {
            //  toast.error(" لم يتم عملية التعديل ");
            alert("Please...Complete The data ");
        }
    };

    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });

    const deleteToI = async (e) => {
        if (params.id > 0 && prevent === false) {
            await e.preventDefault();
            setConfirmDialog({ ...confirmDialog, isOpen: false });
            ButtonLoading("delete");

            await axios.delete(uri + `EmployeeAdvances?id=${params.id}&&branch=${params.branch}`).then(res => {
                // toast.success("Restriction has deleted");
                if (res?.data > 0) {
                    toast.success(t("restriction-deleted-success"));
                    ButtonSuccess("delete", true);

                }
                else {
                    toast.error(res.data);
                    toast.error(res.data);
                    ButtonSuccess("delete", true);

                }
            }).catch(err => {
                console.log("eror", err)
                ButtonSuccess("delete", false);
                toast.error("not delete ")
            })
        }
    };


    // ==== b sd
    const [open, setOpen] = React.useState(false);

    const backHome = () => {
        his.push({ pathname: "/" });
    };
    const back = () => {
        his.goBack();
    };

    const his = useHistory();

    const classes = useStyles();
    const { t } = useTranslation(["forms", "translation"]);

    const isMobileDevice = () => {
        return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
    };
    useEffect(() => {
        if (isMobileDevice()) return;

        const handleKeyDown = async (event) => {
            //  if (event.altKey && event.key ==="p"){
            if (event.key === 'F3') {
                event.preventDefault();
                if (!prevent) return;
                addToBS("save");
            }

            if (event.key === 'F2') {
                event.preventDefault();
                await newToI(1000);
            }
            if (event.key === 'F7') {
                event.preventDefault();
                if (prevent) {
                    addToBS("print");
                } else {
                    if (openUpdate) {
                        addToBS("print");
                    } else {
                        print();
                    }
                }
            }
            if (event.key === 'F4') {
                event.preventDefault();
                if (!prevent) {
                    setOpenUpdate(true);
                }
            }
            if (event.key === 'F6') {
                event.preventDefault();
                if (!prevent) {
                    setConfirmDialog({
                        isOpen: true,
                        onConfirm: () => {
                            deleteToI(event, params.id, setting.screen);
                        },
                    })
                }

            }
            if (event.key === 'F9') {
                event.preventDefault();
                setOpenSearchMdl(true);
            } if (event.key === 'F11') {
                event.preventDefault();
                setOpenButtonsSearch(true);
            }
            if (event.key === 'F8') {
                event.preventDefault();
                back();
            }
            if (event.key === 'Escape') {
                event.preventDefault();
                backHome();

            }


        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };

    }, [params, prevent, confirmDialog, openSearchMdl, setting, confirmDialog]);

    return (
        <div className={classes.root}>
            <Grid container item xs={12}>
                <Typography
                    size="small"
                    className={classes.headerTitle}
                    color="primary"
                    style={{ fontSize: "1.2rem", fontWeight: "bold" }}
                >
                    {t("employee-advances")}
                </Typography>
            </Grid>
            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr", backgroundColor: "#fff" }}
            >

                <Grid container
                    justifyContent="space-around"
                >
                    <Grid item lg={10} md={12} sm={12}
                        style={{ marginTop: "1rem", padding: "1rem" }}>
                        <Container
                            component={Paper}
                            maxWidth={true}
                            style={{
                                paddingTop: "0px",
                                borderColor: "#4a82b9",
                                borderTopWidth: "10px",
                                borderLeftWidth: "0px",
                                borderBottomWidth: "0px",
                                borderRightWidth: "10px",
                                borderStyle: "solid",
                            }}
                        >
                            <Grid container justify="space-between"
                                style={{ paddingBottom: '20px', marginTop: "1rem" }}>
                                <Grid item>
                                    <Chip
                                        size="large"
                                        className={clashd.ChipHdUser}
                                        style={{ fontSize: "1.3rem", fontWeight: "bold" }}
                                        label={t("employee-advance-data")}
                                    />
                                </Grid>

                                <Grid item>
                                    <Avatar className={classes.avatar}>
                                        <AttachMoneyIcon className={classes.icon} />
                                    </Avatar>
                                </Grid>
                            </Grid>

                            <EmployeeAdvancesForm
                                {...{
                                    AutoOptions,
                                    params,
                                    valueAutos,
                                    years,
                                    months,
                                    onChange,
                                    onChangeAuto,
                                    setParams,
                                    setValueAutos,
                                    branch,
                                    AdvancesState,
                                    prevent,
                                    costCenters
                                }}
                            />
                        </Container>
                    </Grid>
                </Grid>

            </Typography>
            <EmployeeAdvancesAppBar {...{
                params,
                buttonClassnameNew,
                buttonClassnameSave,
                buttonClassnameDelete,
                clasCAB,
                newToI,
                setting,
                deleteToI,
                addToBS,
                loading,
                clasBA,
                backHome,
                back,
                uiElement,
                prevent,
                setOpenSearchMdl,
                isLoading,
                setConfirmDialog,
                setOpenUpdate,
                openUpdate,
                print,
                openButtonsSearch,
                onClickButton,
                procIdSearch,
                setOpenButtonsSearch
            }}
            />
            <EmployeeSalarySearch
                {...{
                    openSearchMdl, handCloseDw,
                    onRowClicks, AutoOptions, transition, months, IsSalary: false,
                    costCenters
                }}
            />
            <DeleteConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
        </div>
    );
}
